module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-233.372708d.woff2";